/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FindLotsResponseDto } from '../models/find-lots-response-dto';
import { LotDto } from '../models/lot-dto';
import { Operation } from '../models/operation';

@Injectable({
  providedIn: 'root',
})
export class GeneratedLotService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation findLots
   */
  static readonly FindLotsPath = '/api/lots';

  /**
   * Finds lots.
   *
   * NOTE: Does not raise an error if the given auctionId is not found.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findLots()` instead.
   *
   * This method doesn't expect any request body.
   */
  findLots$Response(params: {
    auc_id?: number;
    cat_id?: number;
    part_id?: number;
    lot_state?: string;
    win_bidder_id?: number;
    '$sortby': string;
    '$sortdir': string;
    '$goto_num'?: string;
    '$page'?: number;
    '$maxpagesize': number;
    '$goto'?: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FindLotsResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedLotService.FindLotsPath, 'get');
    if (params) {
      rb.query('auc_id', params.auc_id, {});
      rb.query('cat_id', params.cat_id, {});
      rb.query('part_id', params.part_id, {});
      rb.query('lot_state', params.lot_state, {});
      rb.query('win_bidder_id', params.win_bidder_id, {});
      rb.query('$sortby', params['$sortby'], {});
      rb.query('$sortdir', params['$sortdir'], {});
      rb.query('$goto_num', params['$goto_num'], {});
      rb.query('$page', params['$page'], {});
      rb.query('$maxpagesize', params['$maxpagesize'], {});
      rb.query('$goto', params['$goto'], {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FindLotsResponseDto>;
      })
    );
  }

  /**
   * Finds lots.
   *
   * NOTE: Does not raise an error if the given auctionId is not found.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findLots$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findLots(params: {
    auc_id?: number;
    cat_id?: number;
    part_id?: number;
    lot_state?: string;
    win_bidder_id?: number;
    '$sortby': string;
    '$sortdir': string;
    '$goto_num'?: string;
    '$page'?: number;
    '$maxpagesize': number;
    '$goto'?: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<FindLotsResponseDto> {

    return this.findLots$Response(params,context).pipe(
      map((r: StrictHttpResponse<FindLotsResponseDto>) => r.body as FindLotsResponseDto)
    );
  }

  /**
   * Path part for operation patchLot
   */
  static readonly PatchLotPath = '/api/lots/{id}';

  /**
   * Patches an existing lot.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchLot()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchLot$Response(params: {
    id: number;
    'X-API-Version'?: string;
    body: Array<Operation>
  },
  context?: HttpContext

): Observable<StrictHttpResponse<LotDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedLotService.PatchLotPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LotDto>;
      })
    );
  }

  /**
   * Patches an existing lot.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchLot$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchLot(params: {
    id: number;
    'X-API-Version'?: string;
    body: Array<Operation>
  },
  context?: HttpContext

): Observable<LotDto> {

    return this.patchLot$Response(params,context).pipe(
      map((r: StrictHttpResponse<LotDto>) => r.body as LotDto)
    );
  }

}
